import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { TherapyForm, type TherapyData } from "./TherapyForm"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & { next_position: number }

export default function TherapiesNew() {
  const { props } = usePage<Props>()

  const empty: TherapyData = {
    slug: "",
    slug_es: "",
    label: "",
    nav_label_en: "",
    nav_label_es: "",
    blurb_en: "",
    blurb_es: "",
    meta_title: "",
    meta_description: "",
    status: "draft",
    position: props.next_position,
  }

  return (
    <AdminShell>
      <Head title="New Therapy Page">
        <meta name="description" content="Add a therapy to Gisela's “Therapies I offer” menu, with a landing page of its own." />
        <meta property="og:title" content="New Therapy Page" />
        <meta property="og:description" content="Add a therapy to Gisela's “Therapies I offer” menu, with a landing page of its own." />
      </Head>

      <Breadcrumbs
        items={[
          { label: "Website Pages", href: "/admin/website" },
          { label: "Gisela Ramirez", href: "/admin/website?brand=gisela" },
          { label: "New therapy page" },
        ]}
      />

      <PageHeader
        title="New therapy page"
        description="Another way Gisela works. The page starts as a draft — you'll write (or AI-draft) its sections next, then publish it."
      />
      <div className="mt-8 max-w-2xl">
        <TherapyForm therapy={empty} actionUrl="/admin/website/therapies" method="post" />
      </div>
    </AdminShell>
  )
}
